/*
  SearchWithin plugin for search bar
 */

bq.searchWithin = function(element, options) {
  this.$element = $(element);
  this.options = options;
  this.supplierUrl = this.$element.data('supplierUrl');
};

bq.searchWithin.DEFAULTS = {
  defaultSelected: 'All',
  matchWidthElement: '#mini-search'
};

bq.searchWithin.prototype = {
  init: function(){
    var self = this;

      //init state
      var $form = $('.search-form form');
      var fq = self.options.fq;
      if (fq) {
        //init state when search by category || supplier
        var searchLabel = '';
        if (fq.hasOwnProperty('category') && fq.hasOwnProperty('category_id')) {
          var categoryId = fq.category_id,
              categoryName = fq.category;

          searchLabel = categoryName;
          $form.append('<input type="hidden" class="hidden-search-within" name="origin" value="category" />');
          $form.append('<input type="hidden" class="hidden-search-within" name="fq[category]" value="' + categoryName + '" />');
          $form.append('<input type="hidden" class="hidden-search-within" name="fq[category_id]" value="' + categoryId + '" />');
          $('#search_marketplace').attr('placeholder', bq.messages.global.searchWithin + categoryName);
          $('#search_marketplace').addClass('suggest-disabled');

        } else if (fq.hasOwnProperty('supplier') && fq.hasOwnProperty('supplier_id')) {
          var supplierId = fq.supplier_id,
              supplierName = fq.supplier;

          searchLabel = supplierName;
          $form.append('<input type="hidden" class="hidden-search-within" name="fq[supplier_id]" value="' + supplierId + '" />');
          $('#search_marketplace').attr('placeholder', bq.messages.global.searchWithin + supplierName);
          $('#search_marketplace').addClass('suggest-disabled');

        }
        self.$element.find('.search-within-current').text(searchLabel);
      } else if ($('body').hasClass('buyerquest-amazonbusiness-search-index')
          || $('body').hasClass('buyerquest-amazoncatalog-search-index')
      ) {
        //init state for search by documents
        var el = $('*[data-search-within-value="amazon_business"]')[0];
        $form.attr('action', $(el).data('url'));
        searchLabel = bq.messages.global.searchAmazonBusiness;
        self.$element.find('.search-within-current').text(searchLabel);
      } else if ($('#main-content').find('.results-view.documents')[0]) {
        //init state for search by documents
        var el = $('*[data-search-within-value="documents"]')[0];
        $form.attr('action', $(el).data('url'));
        searchLabel = bq.messages.global.searchDocuments;
        self.$element.find('.search-within-current').text(searchLabel);
      }

    self.$element.find('.search-within-select').on('click', function(){
      $(this).parent().find('.search-within-items-wrapper').toggleClass('search-within-items-hidden');
      $(this).toggleClass('search-within-select-open');
      self.calibrateWidth();
    });

    self.$element.on('click', '.search-within-item:not(.has-sub-items)', function(){
      self.rebuildSearchInput.call(self, $(this));
    });

    self.$element.on('click', '.search-within-item.has-sub-items', function(){
      $(this).find('.search-within-sub-items').toggleClass('has-sub-items-hidden');
    });

    self.$element.find('#supplier').on('change', function(e){
      self.rebuildSearchInput.call(self, $('#bqat-lnkSearchAll')); // reset the search input to default (Search by All)

      var supplierId = e.added.id,
          supplierName = e.added.text,
          $form = $('.search-form form'),
          $el = $(this);

      $('#search_marketplace').addClass('suggest-disabled');
      $('.search-marketplace .search-input').focus();
      self.closeAndUpdateValue(supplierName);
      $form.find('.hidden-search-within').remove();
      $form.append('<input type="hidden" class="hidden-search-within" name="fq[supplier_id]" value="' + supplierId + '" />');
      $('#search_marketplace').attr('placeholder', bq.messages.global.searchWithin + supplierName);
      $form.attr('action', $el.data('url'));
      self.$element.find('.search-within-select').toggleClass('search-within-select-open');
      self.$element.find('.search-within-items-wrapper').addClass('search-within-items-hidden');
    });

    $('.search-input').on('focus', function(){
      self.$element.find('.search-within-items-wrapper').addClass('search-within-items-hidden');
      self.$element.find('.search-within-select').removeClass('search-within-select-open');
    });

    $('#search_marketplace').on('typeahead:changeSearchWithin', function(e, data){
	    if (data.dataset === 'supplier' || data.dataset === 'category') {

		    if ($(this).val() !==  data.value) {
			    var value = data.value;

			    if(data.dataset === 'category' && data.value.lastIndexOf('&gt') !== -1) {
				    value = data.value.substring(data.value.lastIndexOf('&gt') + '&gt'.length).trim();
			    }

			    self.closeAndUpdateValue(value);
			    self.$element.find('.search-within-select').toggleClass('search-within-select-open');
			    self.$element.find('.search-within-items-wrapper').addClass('search-within-items-hidden');
		    }

		    if(data.datum.link) {
			    window.location = data.datum.link;
		    }

		    data.is_not_suggestion = true;
	    }
    });

    var searchWithin = self.$element.find('.search-within-item');
    if (searchWithin.size() === 1 && searchWithin.data('url')) {
      $form.attr('action', searchWithin.data('url'));
      var type = searchWithin.data('search-within-value');
      type = type.charAt(0).toUpperCase() + type.slice(1);
      if (typeof bq.messages.global['search' + type] !== 'undefined') {
        self.$element.find('.search-within-current').text(bq.messages.global['search' + type]);
      }
    }
  },

  closeAndUpdateValue: function(val){
    var self = this;
    self.$element.find('.search-within-current').text(val);
    self.$element.find('.search-within-items-wrapper').toggleClass('search-within-items-hidden');
    self.$element.find('.search-within-select').toggleClass('search-within-select-open');
  },

  calibrateWidth: function(){
    var self = this;
    var $matchWidth = $(self.options.matchWidthElement);
    self.$element.find('.search-within-items-wrapper').css('width', $matchWidth.width());
  },

  rebuildSearchInput: function($el) {
    var $form = $('.search-form form'),
      searchWithinVal = $el.data('searchWithinValue'),
      self = this,
      oldValue = $form.find('.search-input:visible').val();

    $form.find('.hidden-search-within').remove();
    self.$element.find('.search-within-current').text($el.find('.search-within-text-value').text());
    self.$element.find('.search-within-items-wrapper').toggleClass('search-within-items-hidden');
    self.$element.find('.search-within-select').toggleClass('search-within-select-open');
    self.$element.find('#supplier').select2('val', '');
    self.$element.find('.search-within-sub-items').addClass('has-sub-items-hidden');

    if(searchWithinVal === 'all' || searchWithinVal === 'documents' || searchWithinVal === 'amazon_business') {
      var $input = $form.find($el.data('input'));

      $form.attr('action', $el.data('url'));
      $form.find('.search-input-container').addClass('hide');
      $input.removeClass('hide');
      if(searchWithinVal === 'all') {
        $('#search_marketplace').attr('placeholder', bq.messages.global.searchBar);
      }
      $('#search_marketplace').removeClass('suggest-disabled');
    }

    if($el.hasClass('search-within-category')) {
      $('#search_marketplace').addClass('suggest-disabled');
      $form.append('<input type="hidden" class="hidden-search-within" name="origin" value="category" />');
      $form.append('<input type="hidden" class="hidden-search-within" name="fq[category]" value="' + $el.data('categoryName') + '" />');
      $form.append('<input type="hidden" class="hidden-search-within" name="fq[category_id]" value="' + $el.data('categoryId') + '" />');
      $('#search_marketplace').attr('placeholder', bq.messages.global.searchWithin + $el.data('categoryName'));
      $('.search-manage').addClass('hide');
      $('.search-marketplace').removeClass('hide');
      $form.attr('action', $el.data('url'));
    }

    $form.find('.search-input:visible').val(oldValue);
    self.calibrateWidth();
  }

};

// searchWithin PLUGIN DEFINITION
// =======================

var searchWithinOld = $.fn.searchWithin;

$.fn.searchWithin = function (options) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.searchWithin');
    var _options = $.extend({}, bq.searchWithin.DEFAULTS, $this.data(), typeof(options) === 'object' && options);

    if (!data) { $this.data('bq.searchWithin', (data = new bq.searchWithin(this, _options))); }
    data.init();
  });
};

$.fn.searchWithin.Constructor = bq.searchWithin;

// searchWithin NO CONFLICT
// =================

$.fn.searchWithin.noConflict = function () {
  $.fn.searchWithin = searchWithinOld;
  return this;
};

bq.searchWithinInit = function() {
  $('[data-bq="search-within"]').each(function () {
    var el = $(this);
    if(el.data('bq.searchWithin')) { return; }
    el.searchWithin(el.data());
  });
};

bq.init.push(bq.searchWithinInit);
